import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { PageSkeleton } from '@/components/ui/Skeleton';

/** Keeps shell layouts mounted while lazy route chunks load. */
export function LazyRouteOutlet({ outletKey }: { outletKey?: string | number }) {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Outlet key={outletKey} />
    </Suspense>
  );
}
